import React, { useReducer } from "react";
import { v4 } from "uuid";
import LayoutContext from "./LayoutContext";
import LayoutReducer from "./LayoutReducer";
import { SET_ALERT, REMOVE_ALERT, CLEAR_ALERT, SET_LOADING } from "../types";

const LayoutState = (props) => {
  const initialState = {
    loading: false,
    progress: "",
    alerts: [],
  };

  const [state, dispatch] = useReducer(LayoutReducer, initialState);

  // Set Loading
  const setLoading = (load, progress) => {
    if (progress || parseFloat(progress) === 0) {
      dispatch({
        type: SET_LOADING,
        payload: {
          load,
          progress,
        },
      });
    } else {
      dispatch({
        type: SET_LOADING,
        payload: {
          load,
        },
      });
    }
  };

  // const setAlert = (message, type, timeout = 5000) => {
  const setAlert = (message, type, time) => {
    // TYPE: error, warning, info, success
    const id = v4();
    const timeout = time ? time : 5000;

    let newMessage = true;

    for (var x in state.alerts) {
      if (message === state.alerts[x].message) {
        newMessage = false;
      }
    }

    if (newMessage) {
      dispatch({
        type: SET_ALERT,
        payload: {
          message,
          type,
          id,
        },
      });

      setTimeout(
        () =>
          dispatch({
            type: REMOVE_ALERT,
            payload: id,
          }),
        timeout
      );
    }
  };

  const clearAlerts = () => {
    dispatch({
      type: CLEAR_ALERT,
    });
  };

  return (
    <LayoutContext.Provider
      value={{
        loading: state.loading,
        progress: state.progress,
        alerts: state.alerts,
        setLoading,
        setAlert,
        clearAlerts,
      }}
    >
      {props.children}{" "}
    </LayoutContext.Provider>
  );
};

export default LayoutState;
